<div class="super-admin-padding">
  <div class="super-admin-page theme-background-color">
    <h1>Super admin panel</h1>

    <div class="admin-btn">
      <button
        mat-raised-button
        color="primary"
        routerLink="/super-admin/account"
      >
        Accounts
      </button>

      <button mat-raised-button color="primary" routerLink="/super-admin/org">
        Orgs
      </button>

      <button mat-raised-button color="primary" routerLink="/super-admin/stats">
        Stats
      </button>

      <button
        mat-raised-button
        color="primary"
        routerLink="/super-admin/scripts"
      >
        Scripts
      </button>

      <button mat-raised-button color="primary" routerLink="/debug">
        Debug
      </button>
    </div>
  </div>
</div>
